import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import IconButton from "@mui/material/IconButton";
import { ORDER_STATE_ALL } from "../../../constants/string";
import { useDate } from "../../../contexts/DateContext";

const FilterDropdown = ({ items, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {filter} = useDate();
  const [selectedItems, setSelectedItems] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect (() => {

    if(filter[0] != '*') {
      setSelectedItems(filter);
    }
  },[filter]);

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (selectedItems.includes(value)) {
      setSelectedItems(selectedItems.filter((item) => item !== value));
    } else {
      setSelectedItems([...selectedItems, value]);
    }
  };

  const applyFilters = () => {
    if(selectedItems.length === 0) {
      onSelect([ORDER_STATE_ALL])
    }
    else {
      onSelect(selectedItems);
    }
    
    handleClose();
  };

  return (
    <div>
      <IconButton
        aria-describedby={anchorEl ? "filter-popover" : undefined}
        onClick={handleClick}
        size="large"
      >
        <FilterAltIcon />
      </IconButton>
      <Popover
        id="filter-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <FormGroup sx={{margin: 2}}>
          {items.filter((item) => item.internalOrderStateName !== "*").map((item) => (
            <FormControlLabel
              key={item.displayName}
              control={
                <Checkbox
                  checked={selectedItems.includes(item.internalOrderStateName)}
                  onChange={handleCheckboxChange}
                  value={item.internalOrderStateName}
                />
              }
              label={item.displayName}
            />
          ))}
        </FormGroup>
        <Button sx={{margin: 2}} onClick={applyFilters} variant="contained">
          Apply Filters
        </Button>
      </Popover>
    </div>
  );
}

export default FilterDropdown;
